module.exports = __webpack_public_path__ + "static/media/mirana.a99ef9c9.png";